module.exports = __webpack_public_path__ + "img/hero-temp.412d59e2.jpg";